import { RefreshCw } from 'lucide-react';
import { aufNeueVersionWechseln, useNeueVersion } from '@/lib/pwaUpdate';
import { FOKUS_RING } from '@/lib/fokus';

// Der Hinweis auf eine neue Fassung.
//
// Vorher tauschte sich die Anwendung im Hintergrund selbst aus
// (`registerType: 'autoUpdate'`). Auf einem Gerät, das im Laden den
// ganzen Tag offen steht, heißt das: irgendwann steht plötzlich eine
// andere Fassung da — mitten in einer Erfassung, ohne dass jemand etwas
// getan hätte. Jetzt entscheidet der Mensch, wann.
//
// Der Balken sitzt unten und nicht oben: dort ist der Daumen, und oben
// steht auf dem Telefon die Kopfzeile mit dem Seitentitel. Über der
// Bottom-Navigation, damit er sie nicht verdeckt.

// UNTER DEN DIALOGEN (Befund 28.10.2026): Mit z-[90] lag der Balken über
// jedem Dialog und verdeckte im Erfassungsformular den Knopf „Erstellen".
// Jetzt z-[45]: über der Bottom-Navigation (z-40), unter jedem Dialog
// (ab z-50). Während eines Dialogs wartet er dahinter — erst fertig
// erfassen, dann neu laden.
export function UpdateBanner() {
  const neueVersion = useNeueVersion();
  if (!neueVersion) return null;

  return (
    <div
      role="status"
      // Der Abstand nach unten ist die gemessene Höhe der
      // Bottom-Navigation (61 px im laufenden Build: 56 px Knopf, 4 px
      // Polsterung, 1 px Linie) plus die Sicherheitszone. So sitzt der
      // Balken bündig auf der Leiste, statt sie zu verdecken.
      className="fixed inset-x-3 bottom-3 z-[45] flex flex-wrap items-center justify-between gap-3 rounded-md border border-akzent-linie bg-akzent-sanft px-4 py-3 shadow-sm print:hidden max-md:bottom-[calc(61px+env(safe-area-inset-bottom))] sm:inset-x-auto sm:right-4 sm:max-w-md"
    >
      <span className="text-sm text-ink">Neue Version verfügbar</span>
      <button
        type="button"
        onClick={aufNeueVersionWechseln}
        className={`inline-flex min-h-[44px] items-center gap-2 rounded-md bg-akzent px-4 py-2 text-sm font-medium text-cream hover:bg-akzent-stark ${FOKUS_RING}`}
      >
        <RefreshCw className="h-4 w-4" aria-hidden />
        Neu laden
      </button>
    </div>
  );
}
